export const GROUP_CREATE_OUTCOME = {
  CREATED: 'created',
  SIMILAR_GROUPS: 'similar_groups',
  DOMAIN_BLOCKED: 'domain_blocked',
  FAILED: 'failed'
}

const MATCH_TYPE_PRIORITY = {
  exact_name: 0,
  fuzzy_name: 1
}

export function normalizeGroupCreatePayload (payload) {
  if (typeof payload === 'string') {
    return { userGroupName: payload }
  }

  return payload && typeof payload === 'object' ? payload : {}
}

export function sortSimilarGroups (similarGroups = []) {
  if (!Array.isArray(similarGroups)) return []

  return [...similarGroups].sort((firstGroup, secondGroup) => {
    const firstPriority = MATCH_TYPE_PRIORITY[firstGroup?.match_type] ?? 2
    const secondPriority = MATCH_TYPE_PRIORITY[secondGroup?.match_type] ?? 2
    if (firstPriority !== secondPriority) return firstPriority - secondPriority

    const firstScore = Number(firstGroup?.score) || 0
    const secondScore = Number(secondGroup?.score) || 0
    return secondScore - firstScore
  })
}

export function classifyCreateGroupResponse ({
  responseOk,
  responseStatus,
  responseJSON
} = {}) {
  // The HTTP status is authoritative. confirm_create bypasses only name
  // matching and must never turn a corporate-domain 409 into a create.
  if (responseStatus === 409) return GROUP_CREATE_OUTCOME.DOMAIN_BLOCKED

  if (Array.isArray(responseJSON?.similar_groups) && responseJSON.similar_groups.length > 0) {
    return GROUP_CREATE_OUTCOME.SIMILAR_GROUPS
  }

  if (responseOk && responseStatus === 200 && responseJSON?.group_id) {
    return GROUP_CREATE_OUTCOME.CREATED
  }

  return GROUP_CREATE_OUTCOME.FAILED
}

export function maskEmailAddress (emailAddress = '') {
  const [localPart, domain] = emailAddress.split('@')
  if (!localPart || !domain) return ''

  return `${localPart.charAt(0)}***@${domain}`
}

export function getBlockedOrganization (responseJSON = {}) {
  const response = responseJSON || {}
  const candidates = [
    response,
    response.organization,
    response.existing_group,
    response.group
  ].filter(Boolean)

  for (const candidate of candidates) {
    const groupId = candidate.group_id || candidate.organization_guid || candidate.id
    if (groupId) {
      return {
        groupId,
        groupName: candidate.name || candidate.organization_name || ''
      }
    }
  }

  return null
}
